import { schema } from 'normalizr';
import { SCHEMA_TYPE_VENDOR_ENDPOINTS } from '../constants/schemaTypes';
import vendorEndpointParamSchema from './vendorEndpointParam';

const vendorEndpointSchema = new schema.Entity(SCHEMA_TYPE_VENDOR_ENDPOINTS, {
  resource_parameters: [vendorEndpointParamSchema],
});

export default vendorEndpointSchema;
